/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Per-survey readiness shown on the Review Survey Status step (step 2). Taken purely from the new survey's DataHub displayLoadStatus (mirrors the survey-list Status column): LOADED → available, IN_PROGRESS → processing, EMPTY/UNDER_REVIEW → awaitingData. NOTE: `failed` and `awaitingVendorVerification` are kept in the enum for a forward-complete contract but are NOT emitted yet: displayLoadStatus has no FAILED value, and the vendor-verification source is still an open question (card 134015). `UNDER_REVIEW` folds into awaitingData for now; revisit if it should map to awaitingVendorVerification.
 */
export enum SurveySeasonSurveyReviewStatus {
    AVAILABLE = 'available',
    AWAITING_DATA = 'awaitingData',
    PROCESSING = 'processing',
    FAILED = 'failed',
    AWAITING_VENDOR_VERIFICATION = 'awaitingVendorVerification',
}
